import React, { useState } from "react";
import { format, parse, isValid } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Calendar } from "./ui/calendar";

/**
 * Single, unambiguous date control (no native mm/dd/yyyy mask).
 * Stores value as "yyyy-MM-dd" string.
 */
export const DateField = ({ value, onChange, testId, required }) => {
  const [open, setOpen] = useState(false);
  const selected = value ? parse(value, "yyyy-MM-dd", new Date()) : undefined;
  const label = selected && isValid(selected) ? format(selected, "MM/dd/yyyy") : "Select date";

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testId}
          className={`w-full flex items-center justify-between rounded-md bg-[#F8FAFC] border border-[#D0E2FF] px-3 h-10 text-sm transition-colors hover:border-[#A6C8FF] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#D0E2FF] focus-visible:border-[#60A5FA] ${
            selected ? "text-[#0F172A]" : "text-[#94A3B8]"
          }`}
        >
          <span>{label}{required && !selected ? " *" : ""}</span>
          <CalendarIcon className="w-4 h-4 text-[#60A5FA]" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={selected}
          onSelect={(d) => {
            onChange(d ? format(d, "yyyy-MM-dd") : "");
            setOpen(false);
          }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
};
